import { notification } from 'antd';
type NotificationType = 'success' | 'info' | 'warning' | 'error';
export const CustomeNotification = (type: NotificationType, message: string, description: any, duration: number = 3) => {
    notification[type]({
        message: message || '',
        description: description || '',
        placement: 'top',
        duration: duration
    });
} 